import { currencyTypes } from "../../constants/taxCurrencies";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import { getIsInterState } from "../../utils/taxUtils";
import getReceiptCopies from "./receiptCopies";
import { printCopiesToBridge } from "./CWHardwareController";

export const xmlPrint = (printReciptData, receiptType) => {
  const tillData = useAuthStore.getState().tillData;
  // "Duplicate Copy" reprints always print a single copy, matching htmlPrint's behavior.
  const printCopies = receiptType === "Receipt" ? getReceiptCopies(printReciptData, usePOSConfigStore.getState().posConfig) : 1;
  // New, additive label distinguishing Reprint vs Sales Return (BUG-1822). Left blank when
  // neither applies so existing templates without a @@transactionLabel@@ placeholder are unaffected.
  const transactionLabel = printReciptData.isReturn === true || printReciptData.isReturn === "Y" ? "SALES RETURN" : printReciptData.isReprint ? "REPRINT" : "";
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const pricePrecision = currenciesList?.[0]?.prcPrecision ?? 2;
  let printData = tillData.tillAccess.cwrTill.printTemplate.xmlcode2;
  const printerURL = tillData.tillAccess.cwrTill.hardwareController.imageUrl;

  if (!printData) {
    return printData;
  }

  const isInterState = getIsInterState(printReciptData);
  const addedToCart = printReciptData.items;
  const taxKeyValue = [];
  const taxType = [];
  const isINR = currenciesList[0].isoCode === "INR";

  for (let i = 0; i < addedToCart.length; i += 1) {
    let taxRate = addedToCart[i].taxRate;
    let taxVal = isINR && !isInterState ? addedToCart[i].taxAmount / 2 : addedToCart[i].taxAmount;
    if (taxType.indexOf(taxRate) !== -1) {
      for (let j = 0; j < taxKeyValue.length; j += 1) {
        const keys = Object.keys(taxKeyValue[j]);
        if (keys[0].toString() === taxRate.toString()) {
          taxKeyValue[j][taxRate] = taxKeyValue[j][taxRate] + taxVal;
        }
      }
    } else {
      taxType.push(taxRate);
      taxKeyValue.push({ [taxRate]: taxVal });
    }
  }

  const currencyKey = isINR && isInterState ? "INR_IGST" : currenciesList[0].isoCode;
  let taxTypeCurrencyWise = currencyTypes.filter((item) => item.type === currencyKey);

  let taxAmountBreakup = "";
  taxKeyValue.map((value, i) =>
    taxTypeCurrencyWise[0].taxType?.map(
      (item) =>
        (taxAmountBreakup += `<line>
       <text align="left" length='40'>${item} ${item === "CGST" || item === "SGST" ? taxType[i] / 2 : taxType[i]}%</text>
       <text align="right" length='40'>${value[taxType[i]].toFixed(pricePrecision)}</text>
     </line>`)
    )
  );

  let printItems = "";
  printReciptData.items.map((data) => {
    return (printItems += `<line>
    <text align="left" length='40'>${data.shortDescription === null ? data.name : data.shortDescription}</text>
    <text align="left" length='20'>${parseFloat(data.weight).toFixed(data.isQtyDesimal ?? 2)}</text>
    <text align="left" length='20'>${parseFloat(data.realPrice ?? data.salePrice).toFixed(pricePrecision)}</text>
     </line>
     <line>
     <text align="left" length='20'>${data.hsncode === null ? "-" : data.hsncode}</text>
     ${taxTypeCurrencyWise[0].taxType?.map((item) =>
       item === "CGST" || item === "SGST"
         ? `<text align="left" length='20'>${parseFloat(parseFloat(data.taxAmount) / 2).toFixed(pricePrecision)}</text>`
         : item === "IGST"
         ? `<text align="left" length='20'>${parseFloat(parseFloat(data.taxAmount)).toFixed(pricePrecision)}</text>`
         : `<text align="left" length='20'>${parseFloat(parseFloat(data.taxAmount)).toFixed(pricePrecision)}</text>`
     )}
     <text align="left" length='20'>${parseFloat(data.nettotal).toFixed(pricePrecision)}</text>
     </line>
     `);
  });

  let printPayments = "";
  printReciptData.payments.map((data) => {
    return (printPayments += `<line>
        <text align="left" length='40'>${data.name}</text>
         <text align="right" length='40'>${parseFloat(data.amount).toFixed(pricePrecision)}</text>
      </line>`);
  });

  const customerName = printReciptData.customer.name === "Anonymous Customer" ? "" : printReciptData.customer.name;
  const customerMobile = printReciptData.customer.mobileNo === "9999999999" ? "" : printReciptData.customer.mobileNo;
  const fullAddress = tillData.tillAccess.csBunit.locations[0].fulladdress.replaceAll(", ", ",<br />");

  printData = printData.replace("@@csBunitCustomerAddressFulladdress@@", `${fullAddress}`);
  printData = printData.replace("@@csBunitCustomerAddressPhone@@", `${tillData.tillAccess.csBunit.locations[0].phone}`);
  printData = printData.replace("@@receiptType@@", `${receiptType}`);
  printData = printData.replace("@@transactionLabel@@", `${transactionLabel}`);
  printData = printData.replace("@@username@@", `${localStorage.getItem("username")}`);
  printData = printData.replaceAll("@@printReciptDataDocumentno@@", `${printReciptData.documentno}`);
  printData = printData.replace("@@date@@", `${new Date().toLocaleString()}`);
  printData = printData.replace("@@printReciptDataCustomerName@@", `${customerName}`);
  printData = printData.replace("@@printReciptDataCustomerMobileNo@@", `${customerMobile}`);
  printData = printData.replace("@@printReciptDataItems@@", `${printItems}`);
  printData = printData.replace("@@printReciptDataItemsLength@@", `${parseFloat(printReciptData.items.length).toFixed(0)}`);
  printData = printData.replace("@@printReciptDataTotalQty@@", `${parseFloat(printReciptData.totalQty).toFixed(2)}`);
  printData = printData.replace("@@taxAmountBreakup@@", `${taxAmountBreakup}`);
  printData = printData.replace("@@netAmount@@", `${(parseFloat(printReciptData.total) - parseFloat(printReciptData.tax)).toFixed(pricePrecision)}`);
  printData = printData.replace("@@taxAmount@@", `${parseFloat(printReciptData.tax).toFixed(pricePrecision)}`);
  printData = printData.replace("@@discountAmount@@", `${parseFloat(printReciptData.discount).toFixed(pricePrecision)}`);
  printData = printData.replace("@@grossTotal@@", `${parseFloat(printReciptData.total + printReciptData.discount).toFixed(pricePrecision)}`);
  printData = printData.replace("@@roundOff@@", `${parseFloat(printReciptData.roundOff).toFixed(pricePrecision)}`);
  printData = printData.replace("@@total@@", `${parseFloat(printReciptData.total).toFixed(pricePrecision)}`);
  printData = printData.replace("@@printReciptDataPayments@@", `${printPayments}`);
  printData = printData.replace("@@amountReceived@@", `${parseFloat(printReciptData.paid).toFixed(pricePrecision)}`);
  printData = printData.replace("@@cashChangeAmount@@", `${parseFloat(printReciptData.change).toFixed(pricePrecision)}`);

  // F-17: reuse printCopiesToBridge (CWHardwareController.js) instead of firing all
  // copies concurrently — the bridge acks each POST as soon as it accepts the job,
  // not once the printer has actually finished writing it to paper, so copies need
  // the same real ~1000ms gap already proven to work for that bridge.
  printCopiesToBridge(`${printerURL}printer`, printData, { "Content-Type": "text/plain" }, printCopies);
};
